import { NJSidebarDeprecated, NJSidebarItemDeprecated, NJSidebarMenuDeprecated, NJToastContainer, NJButton } from '@engie-group/fluid-design-system-react';
import { useState, useEffect, useCallback } from 'react';
import { Flex } from "antd";
import './AdminTermsConditions.css';
import { apiGatewayConfig } from '../../../config';
import { invokeLambda, displayNetworkError } from '../../../api';
import { useOktaAuth } from "@okta/okta-react";
import { useUser } from '../../../context/UserContext';
import Loading from '../../../Loading';
import ReactQuill from 'react-quill'; // Import React-Quill
import 'react-quill/dist/quill.snow.css'; // Import styles

const dataType = 'TermsConditions';

const AdminTermsConditions = ({ active }) => {

    const userInfo = useUser();
    const { oktaAuth } = useOktaAuth();

    const [termsList, setTermsList] = useState([]);
    const [termsText, setTermsText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [currentTerms, setCurrentTerms] = useState(null);
    const [currentTermsId, setCurrentTermsId] = useState(null);

    // Quill editor modules/formats configuration
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link'],
            ['clean']
        ],
    };

    const handleLoadTermsList = useCallback(async () => {
        // Prepare request
        const request = {
            action: 'load',
            dataType: dataType,
        }
        setIsLoading(true);
        try {
            const response = await invokeLambda(oktaAuth, apiGatewayConfig.endpointAdminDataManagement, request);
            setTermsList(response.dataset);
        } catch (error) {
            console.error('Error invoking Lambda:', error);
            displayNetworkError(error);
        } finally {
            setIsLoading(false);
        }
    }, [oktaAuth]);

    useEffect(() => {
        if (active) {
            setTermsText('');
            setCurrentTermsId(null);
            handleLoadTermsList();
        }
    }, [active, handleLoadTermsList]);

    useEffect(() => {
        if (termsList.length && !currentTermsId) {
            setCurrentTermsId(termsList[0].id);
            setCurrentTerms(termsList[0])
        }
    }, [termsList, currentTermsId]);

    useEffect(() => {
        if (currentTerms) {
            setTermsText(currentTerms.content);
        }
    }, [currentTerms]);

    const handleUpdate = async (id, content) => {
        // Prepare request
        const request = {
            action: 'update',
            id,
            content,
        }
        setIsLoading(true);
        try {
            await invokeLambda(oktaAuth, apiGatewayConfig.endpointAdminDataManagement, request, userInfo);
        } catch (error) {
            console.error('Error invoking Lambda:', error);
            displayNetworkError(error);
        } finally {
            setIsLoading(false);
        }
    };

    const onSave = async () => {
        // Clean the content before saving
        const cleanedContent = termsText
            .replace(/<p><br><\/p>/g, '')
            .replace(/<p><br\/><\/p>/g, '')
            .replace(/<p><br \/><\/p>/g, '');

        await handleUpdate(currentTermsId, cleanedContent);
        handleLoadTermsList();
    };


    return (
        <>
            {isLoading && <Loading text="Please wait..." />}
            <NJToastContainer type="full-width" />
            <Flex justify='space-between' style={{ width: '100%' }}>
                <div className='admin-terms-sidebar'>
                    <div className='admin-terms-menu'>
                        <NJSidebarDeprecated className='admin-terms-sidebar-deprecated'>
                            <NJSidebarMenuDeprecated>
                                {termsList?.map((item, index) => {
                                    return (
                                        <NJSidebarItemDeprecated

                                            isActive={currentTermsId === item.id}
                                            key={index}
                                            listItemId={item.id}
                                            onClickItem={(e) => { setCurrentTermsId(item.id); setCurrentTerms(item) }}
                                        >
                                            {item.language}
                                        </NJSidebarItemDeprecated>
                                    )
                                })}
                            </NJSidebarMenuDeprecated>
                        </NJSidebarDeprecated>
                    </div>
                </div>
                <div >
                    <div style={{ width: '2px', backgroundColor: '#ccc', height: '100%' }} />
                </div>
                <div className='admin-terms-content'>

                    <div className='admin-terms-title1'>
                        Terms and Conditions of Use
                    </div>
                    <Flex justify='space-between' gap={20} style={{ height: '100%' }}>

                        <div className='admin-terms-text-column'>
                            <div className='admin-terms-quill-container'>

                                <ReactQuill
                                    theme="snow"
                                    value={termsText}
                                    onChange={(value) => {
                                        setTermsText(value)
                                    }}
                                    modules={modules}
                                    className="admin-terms-text"
                                />
                            </div>

                            <Flex justify='flex-end'  >
                                <div className='admin-terms-buttons'>
                                    <NJButton
                                        label="Save"
                                        disabled={false}
                                        onClick={onSave}
                                        icon='save'
                                    />
                                </div>
                            </Flex>
                        </div>

                    </Flex>
                </div>
            </Flex>
        </>
    )
}

export default AdminTermsConditions;